import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import order from './modules/order'
import apiRequest from './modules/apiRequest'
import detail from './modules/detail'
import goodDetail from './modules/goodDetail'
import behaviorScore from './modules/behaviorScore'
import platformType from './modules/platformType'
import collectionClip from './modules/collectionClip'
import remind from './modules/remind'
import popup from './modules/popup'
import user from './modules/user'
import accurate from './modules/accurate'
import { WaitGetFreeCarNum } from '@/api/my'
import permissionDescPopup from './modules/permissionDescPopup'
import guideToAppPopup from './modules/guideToAppPopup'
import * as types from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabBarMyBadge: 0,
    tabBarZeroBadge: {
      WaitGetFreeCardNum: 0,
      TotalFreeCardNum: 0
    },
    sortIndex: 0,
    tabBarShow: true,
    portraitUrl: '',
    loginDialogShow: false,
    authorizePopupShow: false,
    qrCodeIsShow: false, // 关注二维码弹窗是否展示
    curOperateProductId: null, // 当前操作商品id
    shieldDialogShow: false, // 屏蔽原因列表弹窗
    hadShield: false, // 是否屏蔽成功
    isHorizontalScreen: false // 是否横屏
  },
  getters: {
    getTabBarMyBadge: (state) => state.tabBarMyBadge,
    getTabBarZeroBadge: (state) => state.tabBarZeroBadge,
    getSortIndex: (state) => state.sortIndex,
    getTabBarShow: (state) => state.tabBarShow,
    getPortraitUrl: (state) => state.portraitUrl,
    getLoginDialogShow: (state) => state.loginDialogShow,
    getAuthorizePopupShow: (state) => state.authorizePopupShow,
    getQrCodeIsShow: (state) => state.qrCodeIsShow,
    getCurOperateProductId: (state) => state.curOperateProductId,
    getShieldDialogShow: (state) => state.shieldDialogShow,
    getHadShield: (state) => state.hadShield,
    getIsHorizontalScreen: (state) => state.isHorizontalScreen,
    getIsShowRemindBtn: (state, rootStore) => {
      return (!rootStore.getIsApp && rootStore.getIfShowAppDownloadGuide) || (rootStore.getIsApp && rootStore.getIfShowAppReserveRemind)
    }
  },
  mutations: {
    [types.TAB_BAR_MY_BADGE](state, tabBarMyBadge) {
      state.tabBarMyBadge = tabBarMyBadge
    },
    [types.TAB_BAR_ZERO_BADGE](state, tabBarZeroBadge) {
      state.tabBarZeroBadge = tabBarZeroBadge
    },
    [types.SET_SORT_INDEX](state, sortIndex) {
      state.sortIndex = sortIndex
    },
    [types.TAB_BAR_SHOW](state, tabBarShow) {
      state.tabBarShow = tabBarShow
    },
    [types.SET_PORTRAIT_URL](state, portraitUrl) {
      state.portraitUrl = portraitUrl
    },
    [types.LOGINDIALOG_SHOW](state, loginDialogShow) {
      state.loginDialogShow = loginDialogShow
    },
    [types.AUTHORIZE_POPUP_SHOW](state, authorizePopupShow) {
      state.authorizePopupShow = authorizePopupShow
    },
    [types.CUR_PRODUCT_ID](state, curOperateProductId) {
      state.curOperateProductId = curOperateProductId
    },
    [types.SHIELD_DIALOG_SHOW](state, shieldDialogShow) {
      state.shieldDialogShow = shieldDialogShow
    },
    [types.HAD_SHIELD](state, hadShield) {
      state.hadShield = hadShield
    },
    [types.SET_IS_HORIZONTAL_SCREEN](state, isHorizontalScreen) {
      state.isHorizontalScreen = isHorizontalScreen
    }
  },
  actions: {
    waitGetFreeCarNum_Action({ commit }, params = null) {
      WaitGetFreeCarNum(params).then((res) => {
        if (res.Data) commit(types.TAB_BAR_ZERO_BADGE, res.Data)
      })
    }
  },
  modules: {
    login,
    order,
    detail,
    behaviorScore,
    goodDetail,
    apiRequest,
    platformType,
    collectionClip,
    popup,
    accurate,
    user,
    remind,
    permissionDescPopup,
    guideToAppPopup
  }
})
